import React from 'react';
import Portfolio from './Portfolio';
import ThreeScene from './components/ThreeScene';
import './App.css';

function App() {
  return (
    <div className="App">
      <Portfolio />
      <ThreeScene />
    </div>
  );
}


export default App;
